import { FormFieldConstraintBase } from './form-field-constraint-base.model';
import { IFormFieldConstraint } from '../../../interfaces/iform-field-constraint.interface';
import { FormField } from './../form-field.model';
import { FormInstanceElement } from './../form-instance-element.model';

export class NoValueFormFieldConstraint extends FormFieldConstraintBase implements IFormFieldConstraint {
    // Note:  instances of this class can be used to
    //        compare constraint 'id' vand 'name' properties.
    public constructor(dataCollectionId: number, constraintId: number, constraintName: string) {
        super(dataCollectionId, constraintId, null, constraintName);
    }

    // Implement some IFormFieldConstraint methods.
    public get type(): string {
        return null;
    }

    public get constraintExpression(): string {
        return null;
    }
    set constraintExpression(value: string) {
        // NOOP by design.
    }

    // Not relevant for this field type
    public get constraintFailureMessage(): string {
        return null;
    }
    public set constraintFailureMessage(value: string) {
        // noop
    }

    // Logic-related methods.
    public validate(formField: FormField, formInstanceElement: FormInstanceElement): void {
        // NOOP by design.
    }
}
